import * as Api from '@ViewModels';
import { getIntegrationProviderDisplayName } from '../../../../models/utils/integrationUtils';

// Define types for tag search
export enum TagSearchRequestProperty {
	Name = 'Name',
	Favorite = 'Favorite',
}

export interface ITagsSearchFilter {
	criteria: {
		property: TagSearchRequestProperty;
		value?: string;
	}[];
}

export const getTagSearchFromCriteria = (criteria: ITagsSearchFilter['criteria']) => {
	const selected = criteria.find(x => x.property === TagSearchRequestProperty.Name);
	return selected?.value || '';
};

export const DefaultTagsFilter: ITagsSearchFilter = {
	criteria: [{ property: TagSearchRequestProperty.Name, value: '' }],
};

export const DefaultTagsSort: Api.ISortDescriptor = {
	sort: 'asc',
	sortBy: 'name',
};

// The syncs that file tags into categories; the API locks a category whose source is any enabled integration
export const CATEGORY_SYNC_PROVIDERS: Partial<Record<Api.IntegrationSources, Api.IntegrationProvider>> = {
	[Api.IntegrationSources.MicrosoftDynamics365Sales]: Api.IntegrationProvider.MicrosoftDynamics365Sales,
};

/**
 * The API refuses edits to a category its integration's sync owns, but only while that integration is enabled.
 * `enabledProviders` is null until the account's integrations load: the category counts as locked then, but
 * isn't named as synced, since that may not be true.
 */
export const getCategorySyncState = (
	category: Api.ITagCategory | null | undefined,
	enabledProviders: ReadonlySet<Api.IntegrationProvider> | null
): { syncName: string | null; isLocked: boolean } => {
	const provider = category?.source ? CATEGORY_SYNC_PROVIDERS[category.source] : undefined;
	if (!provider) {
		return { syncName: null, isLocked: false };
	}
	if (!enabledProviders) {
		return { syncName: null, isLocked: true };
	}
	return enabledProviders.has(provider)
		? { syncName: getIntegrationProviderDisplayName(provider), isLocked: true }
		: { syncName: null, isLocked: false };
};
